import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export function GenderInput({ 
  value, 
  onChange, 
  onBlur,
  fullWidth = true,
  disabled = false,
  required = false,
  showEmptyOption = true,
  ...props 
}) {
  const labelText = required ? "Gender" : "Gender (optional)";
  const labelId = "gender-select-label";

  const handleChange = (ev) => {
    onChange?.(ev.target.value);
  };

  return (
    <FormControl fullWidth={fullWidth} disabled={disabled} {...props}>
      <InputLabel id={labelId}>{labelText}</InputLabel>
      <Select
        labelId={labelId}
        label={labelText}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
      >
        {showEmptyOption && (
          <MenuItem value="">
            <em>— Select —</em>
          </MenuItem>
        )}
        {genderOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}